module.exports = __webpack_public_path__ + "static/media/sriracha-egger-hero-mobile.321d14d7.jpg";